export default __webpack_public_path__ + "static/sungjinhong-12c8289ef75040963d12f83b2c791f2f.jpeg";